import { getUrlQueryParams, setCookie } from './actions';
import { recreateCustomViewsSection } from './lib/savedviews';
import i18n from './i18n';
import * as basicLightbox from 'basiclightbox';

const dismissSwn = () => {
  Array.from(document.getElementsByClassName('idp-sitewide-notice')).forEach((e) => e.remove());
  setCookie('sitewide-notice-dismissed', true, 365);
};

const autoDismissSitewideNoticeFromUrl = () => {
  const { swn_dismiss: swnDismiss } = getUrlQueryParams();

  const parseUrlParam = (value) => {
    if (value === undefined || value === 'undefined' || value === null) {
      return null;
    }
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  };

  if (typeof swnDismiss !== 'undefined' && swnDismiss !== 'undefined' && parseUrlParam(swnDismiss) === 1) {
    dismissSwn();
  }
};

const videoToggler = () => {
  global.$('.how-video').addClass('d-none');
  const $target = global.$('#how-accordion .card-header button:not(.collapsed)');
  if ($target.length) {
    global.$(`#${$target.attr('rel')}`).removeClass('d-none');
  } else {
    global.$('#overview_img').removeClass('d-none');
  }
};

const imageToggler = () => {
  global.$('.overview-img').addClass('d-none');
  const $target = global.$('#overview-accordion .card-header button:not(.collapsed)');
  if ($target.length) {
    global.$('#overview-accordion-reset').removeClass('active');
    global.$(`#${$target.attr('rel')}`).removeClass('d-none');
  } else {
    global.$('#overview-accordion-reset').addClass('active');
    global.$('#overview_img').removeClass('d-none');
  }
};

const additionalLayoutCorrections = () => {
  // used in copyright
  global.$('.current_year').text(new Date().getUTCFullYear());

  global.$('#how-accordion').on('hidden.bs.collapse', videoToggler);
  global.$('#how-accordion').on('shown.bs.collapse', videoToggler);

  global.$('#overview-accordion').on('hidden.bs.collapse', imageToggler);
  global.$('#overview-accordion').on('shown.bs.collapse', imageToggler);
  global.$('#overview-accordion-reset').on('click', (e) => {
    e.preventDefault();
    global.$('#overview-accordion .card-header button').addClass('collapsed');
    global.$('#overview-accordion .collapse').removeClass('show');
    imageToggler();
  });

  global.$('.country-menu').on('beforeshow', () => {
    global.$('#subjectMenu').attr('hidden', true);
    global.$('#viewMenu').attr('hidden', true);
  });

  global.$('.view-menu').on('beforeshow', () => {
    global.$('#subjectMenu').attr('hidden', true);
    global.$('#countryMenu').attr('hidden', true);
  });

  global.$('.measure-menu').on('beforeshow', () => {
    global.$('#countryMenu').attr('hidden', true);
    global.$('#viewMenu').attr('hidden', true);
  });
};

const lightboxes = () => {
  // eslint-disable-next-line i18next/no-literal-string
  const lightbox = basicLightbox.create(`
    <div class="lb-iframe-wrap">
        <iframe class="lb-iframe" title="vimeo-player" src="https://player.vimeo.com/video/${i18n.t('about_video')}?h=dbbde8f8cb"  frameborder="0"    allowfullscreen></iframe>
    </div>
    `);

  // document.querySelector('.hero-video-launch')?.addEventListener('click', () => {
  //   lightbox.show();
  // });
};

const menuTouchClickFallbacks = () => {
  document.querySelectorAll('.primary-nav a > span').forEach((e) => {
    e.addEventListener('click', (event) => {
      event.preventDefault();
      // toggle open class to nearest a tag
      e.closest('li').classList.toggle('open');
    });
  });
};

export default async () => {
  autoDismissSitewideNoticeFromUrl();
  menuTouchClickFallbacks();

  if (window.location.pathname !== '/data.html' && window.location.pathname !== '/embed.html') {
    recreateCustomViewsSection();
    additionalLayoutCorrections();
    lightboxes();
  }
};
